import React from 'react';

export default function LoaderOverlay({ title, timeLabel, seconds, status }) {
  const getStatusText = (status) => {
    switch (status) {
      case 'IN_QUEUE':
        return 'Töö järjekorras...';
      case 'IN_PROGRESS':
      case 'PROCESSING':
        return 'Töötlemine...';
      case 'COMPLETED':
        return 'Valmis!';
      default:
        return status || 'Töötlemine...';
    }
  };

  return (
    <div className="loader-overlay">
      <div className="loader-card">
        <div className="loader-title">{title}</div>
        <div className="spinner-ring"></div>
        <div className="timer">{timeLabel}: {seconds.toFixed(1)}s</div>
        {/* {status && (
          <div className="status-text">{getStatusText(status)}</div>
        )} */}
      </div>
    </div>
  );
}


